export const formatNumber = (number: number, options: Intl.NumberFormatOptions = {}) => {
  return new Intl.NumberFormat('nb-NO', {
    notation: options.notation ?? 'standard',
    ...options,
  }).format(Number(number));
};

export const formatNumberToParts = (number: number, options: Intl.NumberFormatOptions = {}) => {
  return new Intl.NumberFormat('nb-NO', {
    notation: options.notation ?? 'standard',
    ...options,
  }).formatToParts(Number(number));
};
